module.exports = __webpack_public_path__ + "media/images/poncebattery-banner-3-88550541.jpg";